import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {usePrices} from '../hooks/usePrices.ts';


interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

export const DeleteRecordButton = ({selectedIds, onDeleteComplete}: DeleteRecordButtonProps) => {

    const {deleteRecords} = usePrices();

    const disabled = selectedIds.length === 0;

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={selectedIds.length}
        handleConfirm={() => {
            deleteRecords(selectedIds);
            onDeleteComplete?.();
        }}/>);
};
